var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { BaseSingletonService, Singleton } from '~/services/service.base';
import { UIOpenService } from '~/services/service.ui';
import { t } from 'i18next';
import { ESortingOption } from '~/shared/types';
export let ServiceSorting = class ServiceSorting extends BaseSingletonService {
    openSortingService;
    constructor(openSortingService) {
        super();
        this.openSortingService = openSortingService;
    }
    get options() {
        return [
            {
                label: t('CATEGORY_SORTING_PANEL_DEFAULT'),
                value: ESortingOption.default,
            },
            {
                label: t('CATEGORY_SORTING_PANEL_ASC'),
                value: ESortingOption.asc,
            },
            {
                label: t('CATEGORY_SORTING_PANEL_DESC'),
                value: ESortingOption.desc,
            },
        ];
    }
};
ServiceSorting = __decorate([
    Singleton(),
    __metadata("design:paramtypes", [typeof (_a = typeof UIOpenService !== "undefined" && UIOpenService) === "function" ? _a : Object])
], ServiceSorting);
